import { createAction } from 'typesafe-actions';
import { QuotationIdType, SideMenuState } from './types';

export const INIT_DASHBOARD = 'INIT_DASHBOARD';
export const initDashboard = createAction(INIT_DASHBOARD)();

export const INIT_CHATROOM_ID = 'INIT_CHATROOM_ID';
export const initChatRoomId = createAction(INIT_CHATROOM_ID)();
export const UPDATE_CHATROOM_ID = 'UPDATE_CHATROOM_ID';
export const updateChatRoomId = createAction(UPDATE_CHATROOM_ID)<string>();

export const INIT_PREVIOUS_PATH = 'INIT_PREVIOUS_PATH';
export const initPreviousPath = createAction(INIT_PREVIOUS_PATH)();
export const UPDATE_PREVIOUS_PATH = 'UPDATE_PREVIOUS_PATH';
export const updatePreviousPath = createAction(UPDATE_PREVIOUS_PATH)<string>();

export const INIT_SELECTED_RFQ_ID = 'INIT_SELECTED_RFQ_ID';
export const initSelectedRfqId = createAction(INIT_SELECTED_RFQ_ID)();
export const UPDATE_SELECTED_RFQ_ID = 'UPDATE_SELECTED_RFQ_ID';
export const updateSelectedRfqId = createAction(UPDATE_SELECTED_RFQ_ID)<
  string
>();

export const INIT_SELECTED_CHATROOM_ID = 'INIT_SELECTED_CHATROOM_ID';
export const initSelectedChatRoomId = createAction(INIT_SELECTED_CHATROOM_ID)();
export const UPDATE_SELECTED_CHATROOM_ID = 'UPDATE_SELECTED_CHATROOM_ID';
export const updateSelectedChatRoomId = createAction(
  UPDATE_SELECTED_CHATROOM_ID
)<string>();

export const INIT_SIDE_MENU = 'INIT_SIDE_MENU';
export const initSideMenu = createAction(INIT_SIDE_MENU)();
export const UPDATE_SIDE_MENU = 'UPDATE_SIDE_MENU';
export const updateSideMenu = createAction(UPDATE_SIDE_MENU)<SideMenuState>();

export const INIT_DISABLED_SIDE_MENU = 'INIT_DISABLED_SIDE_MENU';
export const initDisabledSideMenu = createAction(INIT_DISABLED_SIDE_MENU)();
export const UPDATE_DISABLED_SIDE_MENU = 'UPDATE_DISABLED_SIDE_MENU';
export const updateDisabledSideMenu = createAction(UPDATE_DISABLED_SIDE_MENU)<
  SideMenuState[]
>();

export const INIT_QUOTATION_SELECTED = 'INIT_QUOTATION_SELECTED';
export const initSelectedQuotation = createAction(INIT_QUOTATION_SELECTED)();
export const UPDATE_SELECTED_QUOTATION = 'UPDATE_SELECTED_QUOTATION';
export const updateSelectedQuotation = createAction(UPDATE_SELECTED_QUOTATION)<
  QuotationIdType
>();
export const UPDATE_SELECTED_QUOTATION_TYPE = 'UPDATE_SELECTED_QUOTATION_TYPE';
export const updateSelectedQuotationType = createAction(
  UPDATE_SELECTED_QUOTATION_TYPE
)();
